import React, {useState, useEffect, useContext} from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CommonContext } from './../../contexts/constant/ActionTypes';
import './Loader.scss';

const Loader = ({value, text, onlyLoading}) => {
    const commonContext = useContext(CommonContext);

    if (onlyLoading) {
        return(
            <div className='Loader fixed-loader'>
                <CircularProgress color="primary" />
            </div>
        );
    }

    if (commonContext && commonContext.loaderMsg !== '') {
        return(
            <div className='Loader flex-display'>
                <img src="./assets/images/svg/NoDataFound.svg" />
                <div className='loader-msg'>{commonContext.loaderMsg}</div>
            </div>
        );
    }

    if( value ){
        return(
            <CircularProgress variant="static" value={value} />            
        );
    }
    
    return (
        <div className='Loader fixed-loader'>
            <CircularProgress color="primary" />
        </div>
    );
}

Loader.propTypes = {
    value: PropTypes.number,
    text: PropTypes.string,
    onlyLoading: PropTypes.bool
};

Loader.defaultProps = {
    value: null,
    text: '',
    onlyLoading: false
};

export default Loader;


// WEBPACK FOOTER //
// ./common/Loader/Loader.js